export class MenuIcons
{
    public static Home = 'home.svg';
    public static OpsTower = 'opstower.svg';
    public static Application = 'application.svg';
    public static LGU = 'lgu.svg';
    public static Comms = 'comms.svg';
    public static Reports = 'reports.svg';
    public static Marketing = 'marketing.svg';
    public static Finance = 'finance.svg';
    public static Settings = 'settings.svg';
    public static Audit = 'application.svg';
    public static Orders = 'icon_order.svg';
    public static Locations = 'icon_locations.svg';
    public static Insights = 'icon_insights.svg';
    public static Registration = 'application.svg';
}

export class PartnerMenuIcons
{
    public static Search = 'search';
    public static Home = 'home';
    public static Orders = 'shopping_bag';
    public static Menu = 'menu_book';
    public static Inventory = 'inventory_2';
    public static Locations = 'storefront';
    public static Finance = 'payments';
    public static Insights = 'insights';
    public static Settings = 'settings';
    public static Marketing = 'ad';
    public static Help = 'help';
}

export class TourOperatorMenuIcons {
    public static Experience = 'icon-experience.svg';
    public static Dashboard = 'icon-dashboard.svg';
    public static OperatorReg = 'icon-operator-reg.svg';
    public static ListingReview = 'icon-listing-review.svg';
    public static BookingOversight = 'icon-booking-oversight.svg';
    public static Compliance = 'icon-compliance.svg';
    public static Notification = 'icon-notification.svg';
    public static Sandbox = 'icon-sandbox.svg';
}
